var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17.875,
    viewBox: "0 0 22 17.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4596",
    "data-name": "Path 4596",
    d: "M-7.483-12.714a.884.884,0,0,1-.739.3.806.806,0,0,1-.756-.3L-10.7-14.433a.986.986,0,0,1,0-1.421,1.031,1.031,0,0,1,1.458,0l.95.948,2.368-2.628a1.031,1.031,0,0,1,1.457-.076,1.032,1.032,0,0,1,.073,1.457l-3.092,3.439Zm0,6.875a.884.884,0,0,1-.739.3.806.806,0,0,1-.756-.3L-10.7-7.558a.988.988,0,0,1,0-1.422,1.037,1.037,0,0,1,1.458,0l.95.95,2.368-2.63a1.032,1.032,0,0,1,1.457-.073,1.032,1.032,0,0,1,.073,1.457L-7.483-5.839Zm5.765-8.254A1.029,1.029,0,0,1-2.75-15.125a1.03,1.03,0,0,1,1.031-1.031H9.969A1.03,1.03,0,0,1,11-15.125a1.029,1.029,0,0,1-1.031,1.031ZM-2.75-8.25A1.029,1.029,0,0,1-1.719-9.281H9.969A1.029,1.029,0,0,1,11-8.25,1.029,1.029,0,0,1,9.969-7.219H-1.719A1.029,1.029,0,0,1-2.75-8.25ZM-4.125-1.375A1.029,1.029,0,0,1-3.094-2.406H9.969A1.029,1.029,0,0,1,11-1.375,1.029,1.029,0,0,1,9.969-.344H-3.094A1.029,1.029,0,0,1-4.125-1.375ZM-8.25,0A1.374,1.374,0,0,1-9.625-1.375,1.374,1.374,0,0,1-8.25-2.75,1.374,1.374,0,0,1-6.875-1.375,1.374,1.374,0,0,1-8.25,0Z",
    transform: "translate(11 17.875)",
    fill: "#707070"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedList);
export default __webpack_public_path__ + "static/media/checked-list.54cf71087936a992d3083d9e54095da6.svg";
export { ForwardRef as ReactComponent };